import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { InvestmentSummary } from '../../types/stakeholder.types';
import { useAppQuery } from '../use-app-query.hook';

export const useInvestmentSummary = ({
  companyId,
  enabled = true,
  stakeholderId,
}: {
  companyId: string;
  enabled?: boolean;
  stakeholderId: string;
}) => {
  const queryClient = useQueryClient();
  const { data: investmentSummary, isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_INVESTMENT_SUMMARY, companyId, stakeholderId],
    queryFn: () =>
      ApiService.get<InvestmentSummary>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'investment-summary'],
      }),
    enabled: enabled && !!companyId && !!stakeholderId,
  });

  const invalidateQuery = () => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_INVESTMENT_SUMMARY] });
  };

  return {
    investmentSummary,
    isLoading,
    invalidateQuery,
  };
};
